// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"768":"65f9cb3d","887":"8f4c3676"}[chunkId] + ".css";
};